/**
 * Auto-generated by `npm run studio -- codegen`. Do not edit by hand.
 * Re-run the studio for this pack instead of editing piece entries.
 */
import { PIECE_VALUES } from '@blind-kings/game-core';
import type { SkinPack, SpriteDef } from './types';
import knightStatic from '../sheets/realm/knight.static.png';
import knightResting from '../sheets/realm/knight.resting.png';
import knightHover from '../sheets/realm/knight.hover.png';
import knightMoving from '../sheets/realm/knight.moving.png';
import knightAttacking from '../sheets/realm/knight.attacking.png';
import knightRevealing from '../sheets/realm/knight.revealing.png';
import knightDead from '../sheets/realm/knight.dead.png';

const pieces: Partial<Record<number, SpriteDef>> = {
  [PIECE_VALUES.Knight]: {
    kind: 'sheet',
    staticUrl: knightStatic,
    frameWidth: 128,
    frameHeight: 128,
    strips: {
      resting: { url: knightResting, frameCount: 14, fps: 8 },
      hover: { url: knightHover, frameCount: 12, fps: 12 },
      moving: { url: knightMoving, frameCount: 12, fps: 14 },
      attacking: { url: knightAttacking, frameCount: 6, fps: 24 },
      revealing: { url: knightRevealing, frameCount: 10, fps: 24 },
      dead: { url: knightDead, frameCount: 12, fps: 14 },
    },
  },
};

export const realmSkinPack: SkinPack = {
  id: 'realm',
  label: 'Realm',
  pieces,
  interactions: {
    move: {
      timings: {
        windup: 100,
        depart: 50,
        travel: 350,
        land: 150,
        cooldown: 50
      }
    },
    attack: {
      timings: {
        windup: 150,
        depart: 50,
        travel: 400,
        resolve: 200,
        cooldown: 50,
        clash: 667
      }
    },
    flip: {
      timings: {
        pulse: 100,
        cooldown: 50,
        reveal: 417
      }
    }
  },
};
